import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import certificationsConfig from '../../config/certificationsConfig.json';
import './Certifications.css';

const Certifications = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { labelKey: 'nav.aboutUs', href: '/#about-us' },
    { labelKey: 'aboutUs.certifications' }
  ];

  return (
    <PageTemplate 
      titleKey="pages.certifications.title"
      subtitleKey="pages.certifications.subtitle"
      breadcrumbs={breadcrumbs}
    >
      <div className="content-card certifications-content">
        <h2>{t('pages.certifications.intro.title')}</h2>
        <p>{t('pages.certifications.intro.description')}</p>

        <h3>{t('pages.certifications.professional.title')}</h3>
        <div className="certifications-grid">
          {certificationsConfig.professionalCertifications.map((cert, index) => (
            <div key={index} className="cert-card">
              <span className="cert-icon">{cert.icon}</span>
              <h4>{t(cert.titleKey)}</h4>
              <p>{t(cert.issuerKey)}</p>
            </div>
          ))}
        </div>

        <h3>{t('pages.certifications.awards.title')}</h3>
        <ul className="awards-list">
          {certificationsConfig.awards.map((award, index) => (
            <li key={index}>
              <strong>{t(award.titleKey)}</strong> - {t(award.descriptionKey)}
            </li>
          ))}
        </ul>

        <div className="feature-box">
          <h4>{t('pages.certifications.commitment.title')}</h4>
          <p>{t('pages.certifications.commitment.description')}</p>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Certifications;
